import React from "react";

import { connect } from "react-redux";

import ZeeTable from "components/ZeeTable";
import ZeeLevelChip from "components/ZeeLevelChip";

import CheckoutItem from "./item-suppliers";
import "./style.scss";

import { getLevels, getRequiredStock, getPendingStock } from "selectors/stock";

class Checkout extends React.Component {
  state = {
    rows: [],
  };

  columns = {
    name: { name: "Stock Item" },
    currentLevel: {
      name: "Stock Level",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        return (
          <ZeeLevelChip
            label={levels.currentLevel}
            color="primary"
            title="Current"
          />
        );
      },
    },
    requiredLevel: {
      name: "Required Stock",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        return (
          <ZeeLevelChip
            label={levels.requiredLevel}
            title="Stock required for order"
          />
        );
      },
    },
    pendingLevel: {
      name: "Pending Stock",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        return (
          <ZeeLevelChip label={levels.pendingLevel} title="Stock in purchase" />
        );
      },
    },
    thisLevel: {
      name: "This Purchase",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = 0;
        return (
          <ZeeLevelChip label={this.item.quantity ?? 0} title="From below" />
        );
      },
    },
    futureLevel: {
      name: "Future Stock",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        const style =
          levels.futureLevel < 0
            ? {
                background: "red",
                color: "white",
              }
            : {
                background: "lightgreen",
              };

        return (
          <ZeeLevelChip
            label={levels.futureLevel}
            title="Stock after purchases and orders"
            style={style}
          />
        );
      },
    },
  };

  getLevels(stockId) {
    const { currentLevel, pendingLevel, requiredLevel, ...rest } = getLevels(
      this.props.stockLedger,
      this.requiredStock,
      this.pendingStock,
      stockId
    );

    const quantity = this.item.quantity ?? 0;

    return {
      ...rest,
      currentLevel,
      pendingLevel,
      requiredLevel,
      futureLevel: currentLevel + pendingLevel + requiredLevel + quantity,
    };
  }

  __pendingStock = null;
  get pendingStock() {
    if (!this.__pendingStock) {
      this.__pendingStock = getPendingStock(
        this.props.purchase,
        this.props.purchaseItem
      );
    }
    return this.__pendingStock;
  }

  __requiredStock = null;
  get requiredStock() {
    if (!this.__requiredStock) {
      this.__requiredStock = getRequiredStock(
        this.props.order,
        this.props.orderItem,
        this.props.productStock,
        this.props.productGroup
      );
    }
    return this.__requiredStock;
  }

  get classNames() {
    const classes = ["checkout"];

    if (this.isVisible) {
      classes.push("is-visible");
    }

    return classes.join(" ");
  }

  get isVisible() {
    return this.props.isVisible;
  }

  onToggle() {
    return this.props.onToggle();
  }

  onSelectionConfirm() {}

  onRowsUpdate(rows) {
    return this.props.onUpdate?.({ ...this.item, rows });
  }

  get item() {
    return this.props.item;
  }

  render() {
    // const suppliers = this.selection.map((stockId) =>
    //   this.props.stockSupplier.filter(
    //     (stockSupplier) => stockSupplier.stock_id === stockId
    //   )
    // );

    return (
      <ZeeTable
        onRowsUpdate={(rows) => this.onRowsUpdate(rows)}
        columns={this.columns}
        data={[{ ...this.item }]}
        orderBy="name"
        rowComponent={CheckoutItem}
        rowComponentHeader={false}
      />
    );
  }
}
export default connect((state) => {
  return {
    order: state.order.all,
    orderItem: state.order.item.all,
    product: state.product.all,
    productStock: state.product.stock.all,
    productGroup: state.product.group.all,
    stock: state.stock.all,
    stockSupplier: state.stock.supplier.all,
    stockLedger: state.stock.ledger.all,
    supplier: state.supplier.all,
    purchase: state.purchase.all,
    purchaseItem: state.purchase.item.all,
  };
})(Checkout);
